import React from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import NumberFormat from "react-number-format";
import { MANAGER_DONATION_LIST_QUERY } from "../Queries";
import { Panel, PanelHeader, PanelBody } from "../../../Components/Panel/Panel";

export default withRouter(({ location }) => {
  const { data, loading } = useQuery(MANAGER_DONATION_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  if (loading || !data || !data.ManagerDonationList) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  const donations = data.ManagerDonationList;

  return (
    <>
      <Helmet>
        <title>담당 기부 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item active">담당 기부</li>
        </ol>
        <h1 className="page-header">담당 기부</h1>

        <Panel>
          <PanelHeader noButton={true}>담당 기부 목록</PanelHeader>
          <PanelBody className="p-0">
            <div className="table-responsive">
              <table className="table table-bordered table-striped m-b-0">
                <thead>
                  <tr>
                    <th>기부명</th>
                    <th>주관</th>
                    <th>모금액(DRM)</th>
                    <th style={{ width: 320 }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {donations.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        담당하는 기부가 없습니다.
                      </td>
                    </tr>
                  )}
                  {donations.map((donation) => (
                    <tr key={donation.id}>
                      <td>{donation.title}</td>
                      <td>{donation.planner}</td>
                      <td>
                        <NumberFormat
                          value={donation.totalDRM}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </td>
                      <td>
                        <Link
                          to={`/manager/donations/${donation.id}/edit${location.search}`}
                          className="btn btn-white btn-xs m-r-5"
                        >
                          <i className="fa fa-info-circle m-r-5"></i>정보
                        </Link>
                        <Link
                          to={`/manager/donations/${donation.id}/ledgers${location.search}`}
                          className="btn btn-white btn-xs text-green m-r-5"
                        >
                          내역
                        </Link>
                        <Link
                          to={`/manager/donations/${donation.id}/taxInfos${location.search}`}
                          className="btn btn-white btn-xs text-blue"
                        >
                          소득공제신고 내역
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </>
  );
});
